import React, { FunctionComponent } from 'react';
import { Experiments } from '../../constants/experiments';

import { DonateButton } from '../DonateButton/DonateButton';
import { Share } from '../SocialButtons/Share';

const FundraisingCTA: FunctionComponent = () => {
  return (
    <>
      <DonateButton
        key="donateButton"
        className="jg-space-mrsm jg-space-mrn@lg jg-space-mbsm"
        trackingDataPageSection="FundraisingCTA"
        experiments={[Experiments.donate_now_track_click]}
        successType="StaticDonateButtonClick"
      />
      <Share />
    </>
  );
};

export default FundraisingCTA;
